import { useState } from 'react'
import { Chessboard } from 'react-chessboard'
import { motion } from 'framer-motion'

export interface ChessboardDisplayProps {
  fen: string
  boardWidth?: number
  showLabel?: boolean
}

const ChessboardDisplay = ({
  fen,
  boardWidth = 400,
  showLabel = true,
}: ChessboardDisplayProps) => {
  const [boardOrientation] = useState<'white' | 'black'>('white')

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.3, delay: 0.1 }}
      className="w-full"
    >
      {showLabel && (
        <h3 className="text-sm font-semibold text-gray-600 dark:text-dark-300 uppercase tracking-wider mb-3">
          Board Visualization
        </h3>
      )}

      <div className="flex justify-center">
        <div
          className="rounded-lg overflow-hidden shadow-xl border-2 border-gray-200 dark:border-dark-700"
          style={{ width: '100%', maxWidth: boardWidth }}
        >
          <Chessboard
            position={fen}
            boardOrientation={boardOrientation}
            arePiecesDraggable={false}
            customBoardStyle={{
              borderRadius: '0px',
            }}
            customDarkSquareStyle={{
              backgroundColor: '#779952',
            }}
            customLightSquareStyle={{
              backgroundColor: '#edeed1',
            }}
          />
        </div>
      </div>
    </motion.div>
  )
}

export default ChessboardDisplay
